import moment from 'moment';
import { DateFormats } from 'constants/common';
import { DealActivityStatus } from '@trnsact/trnsact-shared-types';

import { ListingFiltersValues } from './ui/table/types';

const today = moment();

export const INITIAL_FILTERS: ListingFiltersValues = {
  filters: {
    search: '',
    type: [],
    status: [],
    priority: [],
    dateRange: {
      from: today.clone().startOf('day').format(DateFormats.ISO),
      to: today.clone().endOf('day').format(DateFormats.ISO),
    },
  },
};

export const quickFiltersConfig: { label: string; value: Partial<ListingFiltersValues['filters']> }[] = [
  {
    label: 'Today',
    value: {
      status: [],
      dateRange: {
        from: today.clone().startOf('day').format(DateFormats.ISO),
        to: today.clone().endOf('day').format(DateFormats.ISO),
      },
    },
  },
  {
    label: 'Tomorrow',
    value: {
      status: [],
      dateRange: {
        from: today.clone().add(1, 'day').startOf('day').format(DateFormats.ISO),
        to: today.clone().add(1, 'day').endOf('day').format(DateFormats.ISO),
      },
    },
  },
  {
    label: 'Next 30 Days',
    value: {
      status: [],
      dateRange: {
        from: today.clone().startOf('day').format(DateFormats.ISO),
        to: today.clone().add(30, 'days').endOf('day').format(DateFormats.ISO),
      },
    },
  },
  {
    label: 'Complete',
    value: {
      dateRange: null,
      status: [DealActivityStatus.Closed],
    },
  },
];
